import React from 'react';
import { NavLink } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Gallery } from '../components/Gallery';
import { SITE_IMAGES, getCdnImage } from '../data/content';

export function Projekter() {
  return (
    <>
      <SEO
        title="Projekter & Referencer – SYSTEM 3E"
        description="Se eksempler på moderne enfamiliehuse, rækkehuse og erhvervsbyggerier opført med SYSTEM 3E. Gallerier med billeder af færdige huse og byggeprocessen."
      />

      {/* Hero */}
      <section className="bg-[#243447] text-white py-16 sm:py-24 relative overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={getCdnImage(SITE_IMAGES.villaVordingborg, 1600, 80)}
            alt="SYSTEM 3E Referencer"
            className="w-full h-full object-cover opacity-45"
          />
          <div className="absolute inset-0 bg-[#162332]/45" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-[#819FA8] font-extrabold text-xs uppercase tracking-widest block mb-2">
              Inspiration & Referencer
            </span>
            <h1 className="text-3xl sm:text-5xl font-black text-white tracking-tight mb-6">
              SYSTEM 3E i Virkeligheden
            </h1>
            <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
              Udforsk udvalgte bolig- og erhvervsbyggerier. Fra stram nordisk arkitektur til funktionelle rækkehuse opført med den bæredygtige perlit-vægteknologi.
            </p>
          </div>
        </div>
      </section>

      {/* Main CMS Gallery Section: Projekter */}
      <section className="py-16 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <span className="text-red-600 font-bold text-xs uppercase tracking-widest block mb-1">
              Hovedgalleri
            </span>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900">
              Udvalgte Byggeprojekter
            </h2>
            <p className="text-slate-600 text-sm mt-1">
              Klik på billederne for at åbne stor visning i lightbox.
            </p>
          </div>

          <Gallery gallerySlug="projekter" />
        </div>
      </section>



      {/* Bottom CTA */}
      <section className="py-16 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-4xl font-extrabold text-white mb-4">
            Vil du opføre et tilsvarende projekt?
          </h2>
          <p className="text-slate-300 text-sm sm:text-base max-w-xl mx-auto mb-8">
            Kontakt AGT Nordic Group ApS for rådgivning, tegningsgennemgang og tilbud.
          </p>
          <NavLink
            to="/kontakt"
            className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-4 rounded-xl text-base transition-all inline-block shadow-lg"
          >
            Drøft dit projekt med den danske eneforhandler
          </NavLink>
        </div>
      </section>
    </>
  );
}
